<ng-container *ngIf="eventDetails">
	<h1>{{eventDetails.name}}</h1>
	<!-- <h3>{{eventDetails.date | date}}</h3> -->
	<div class="margin-bottom-10 text-center">
		<img class="img-responsive"
		 [src]="eventDetails.postcard"
		 style="display: inline;"
		 [alt]="eventDetails.name">
		<br>
		<br>
	</div>
</ng-container>
